// extracted by mini-css-extract-plugin
module.exports = {"container":"market__container___3VAIG","name":"market__name___2HszL","odds":"market__odds___3URGG"};